









































import Vue from 'vue';

import aboutFigureOne from '@/assets/about_one.png';
import aboutFigureTwo from '@/assets/about_two.png';
import aboutFigureThree from '@/assets/about_three.png';


export default Vue.extend({
  name: 'about-us',
  data () {
    return {
      aboutFigureOne,
      aboutFigureTwo,
      aboutFigureThree,
    };
  },
});
